var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-company-info"},[_vm._v(" 40000+企业部署商用 | 100+产品软著 | 广东省高新技术企业 | 重合同信用企业 | 科技型中小企业 | 专精特新中小企业 "),_c('strong',[_vm._v("服务热线:15216771448")])])
}]

export { render, staticRenderFns }